import { render, staticRenderFns } from "./HeaderPrivacy.vue?vue&type=template&id=ea1638ca&scoped=true&"
import script from "./HeaderPrivacy.vue?vue&type=script&lang=js&"
export * from "./HeaderPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPrivacy.vue?vue&type=style&index=0&id=ea1638ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1638ca",
  null
  
)

export default component.exports